import retrieveAllTags from 'app/modules/teamsOld/sagas/retrieveAllTags';
import addTag from 'app/modules/teamsOld/sagas/addTag';
import watchRetrieveAPIConfigs from 'app/modules/teamsOld/sagas/retrieveAPIConfigs';

const sagaRegistry = [retrieveAllTags, addTag, watchRetrieveAPIConfigs];

export default sagaRegistry;
